"use client";
import { Sizes } from "@/lib/centra/hooks/useSizes";
import Script from "next/script";
import { memo, useState } from "react";
import { EasySizeOptions, useEasySize } from "./easysize";
import styles from "./index.module.css";

interface Props {
  config: EasySizeOptions;
  sizes: Sizes;
}

export const EasySizeButton = memo(({ config, sizes }: Props) => {
  const [loaded, setLoaded] = useState(false);

  const _easySize = useEasySize(config, {
    enabled: loaded,
  });

  const handleSizeChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedItemId = e.target.selectedOptions[0]?.dataset?.itemId;
    const foundSize = sizes?.find(size => size.itemId === selectedItemId);

    if (!foundSize) {
      console.warn("Size not found", selectedItemId);
      return;
    }

    foundSize?.selectSize();
  };

  return (
    <>
      <div className={styles.buttonRoot}>
        <div className="sr-only" id="product_size"></div>
        <div id="product_recommendation"></div>

        <select
          className="sr-only"
          onChange={handleSizeChange}
          title="placeholder_size_selector"
          id="size_dropdown"
        >
          {sizes?.map(size => (
            <option
              key={size.itemId}
              data-item-id={size.itemId}
              value={size.name}
            >
              {size.name}
            </option>
          ))}
        </select>
      </div>
      <Script
        src="https://webapp.easysize.me/web_app_v1.0/js/easysize.js"
        onReady={() => setLoaded(true)}
      />
    </>
  );
});

EasySizeButton.displayName = "EasySizeButton";
